import { render } from "./MultiSelect.vue?vue&type=template&id=65975d29&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=js"
export * from "./MultiSelect.vue?vue&type=script&lang=js"

import "./MultiSelect.vue?vue&type=style&index=0&id=65975d29&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65975d29"

export default script